<div class="advertisement">
  @if (size === 'phone') {
  <div [id]="formats?.phone + '-' + unique"></div>
  } @else {
  <div [id]="formats?.desktop + '-' + unique"></div>
  }
  <ng-template #desktop>
    <div [id]="formats?.desktop + '-' + unique"></div>
  </ng-template>
</div>
